<template>
  <div class="account-manager w-full bg-black" style="margin-top: 80px;">
    <!-- Job Description Section -->
    <section class="pt-20 pb-10 md:pt-30 md:pb-20 lg:pt-40 lg:pb-30 px-6">
      <div class="max-w-4xl mx-auto">
        <!-- Job Title and Location -->
        <div class="text-center mb-12">
          <h1 class="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-4xl font-light mb-3 md:mb-6 leading-tight text-white uppercase">
            {{ accountManager.title || '' }}
          </h1>
          <p class="text-white text-lg uppercase mb-6 md:mb-12">{{ accountManager.location || '' }}</p>
        </div>

        <!-- Introduction Paragraphs -->
        <div class="space-y-6 text-white text-lg leading-relaxed mb-16 text-center">
          <p v-for="(paragraph, index) in (accountManager.introduction || [])" :key="index">{{ paragraph }}</p>
        </div>

        <!-- What We Expect Section -->
        <div class="mb-16 text-center">
          <h2 class="text-xl md:text-2xl font-normal text-white uppercase mb-8">{{ accountManager.whatWeExpect?.title || '' }}</h2>
          <ul class="space-y-4 text-white text-lg leading-relaxed">
            <li v-for="(expectation, index) in (accountManager.whatWeExpect?.items || [])" :key="index" class="flex items-start justify-center">
              <span class="text-white mr-3 mt-1">•</span>
              <span>{{ expectation }}</span>
            </li>
          </ul>
        </div>

        <!-- Responsibilities Section -->
        <div class="mb-16 text-center">
          <h2 class="text-xl md:text-2xl font-normal text-white uppercase mb-8">{{ accountManager.responsibilities?.title || '' }}</h2>
          <ul class="space-y-4 text-white text-lg leading-relaxed">
            <li v-for="(responsibility, index) in (accountManager.responsibilities?.items || [])" :key="index" class="flex items-start justify-center">
              <span class="text-white mr-3 mt-1">•</span>
              <span>{{ responsibility }}</span>
            </li>
          </ul>
        </div>

        <!-- Qualifications Section -->
        <div class="mb-16 text-center">
          <h2 class="text-xl md:text-2xl font-normal text-white uppercase mb-8">{{ accountManager.qualifications?.title || '' }}</h2>
          <ul class="space-y-4 text-white text-lg leading-relaxed">
            <li v-for="(qualification, index) in (accountManager.qualifications?.items || [])" :key="index" class="flex items-start justify-center">
              <span class="text-white mr-3 mt-1">•</span>
              <span>{{ qualification }}</span>
            </li>
          </ul>
        </div>

        <!-- What We Offer Section -->
        <div class="mb-16 text-center">
          <h2 class="text-xl md:text-2xl font-normal text-white uppercase mb-8">{{ accountManager.whatWeOffer?.title || '' }}</h2>
          <ul class="space-y-4 text-white text-lg leading-relaxed">
            <li v-for="(offer, index) in (accountManager.whatWeOffer?.items || [])" :key="index" class="flex items-start justify-center">
              <span class="text-white mr-3 mt-1">•</span>
              <span>{{ offer }}</span>
            </li>
          </ul>
        </div>

        <!-- Location & Arrangement Section -->
        <div class="mb-16 text-center">
          <h2 class="text-xl md:text-2xl font-normal text-white uppercase mb-8">{{ accountManager.locationArrangement?.title || '' }}</h2>
          <ul class="space-y-4 text-white text-lg leading-relaxed">
            <li v-for="(location, index) in (accountManager.locationArrangement?.items || [])" :key="index" class="flex items-start justify-center">
              <span class="text-white mr-3 mt-1">•</span>
              <span>{{ location }}</span>
            </li>
          </ul>
        </div>

        <!-- First 90 Days Section -->
        <div class="mb-16 text-center">
          <h2 class="text-xl md:text-2xl font-normal text-white uppercase mb-8">{{ accountManager.first90Days?.title || '' }}</h2>
          <ul class="space-y-4 text-white text-lg leading-relaxed">
            <li v-for="(day, index) in (accountManager.first90Days?.items || [])" :key="index" class="flex items-start justify-center">
              <span class="text-white mr-3 mt-1">•</span>
              <span>{{ day }}</span>
            </li>
          </ul>
        </div>

        <!-- How to Apply Section -->
        <div class="mb-16 text-center">
            <h2 class="text-xl md:text-2xl font-normal text-white uppercase mb-8">{{ accountManager.howToApply?.title || '' }}</h2>
            <p class="text-white text-lg leading-relaxed mb-12">
              {{ accountManager.howToApply?.text || '' }}
              <a :href="'mailto:' + (accountManager.howToApply?.email || '')" class="text-white underline hover:no-underline transition-all duration-300">
                {{ accountManager.howToApply?.email || '' }}
              </a>
              {{ accountManager.howToApply?.subject || '' }}
            </p>
            
            <!-- Back Button -->
            <div class="mt-16">
              <router-link :to="getLocalizedRoute('work-with-us')" class="inline-block leading-tight text-lg uppercase border border-white text-white px-8 py-3 rounded-full hover:bg-white hover:text-black transition-colors duration-300">
                {{ t('common.back') }}
              </router-link>
            </div>
        </div>

    </div>

    </section>

    <!-- Divider -->
    <div class="w-full border-b border-white"></div>
 
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import pt from '@/i18n/locales/pt.js'
import enUS from '@/i18n/locales/en-US.js'

export default {
  name: 'AccountManager',
  setup() {
    const { t, locale } = useI18n()
    
    // Computed properties para acessar as traduções de forma segura
    const accountManager = computed(() => {
      const messages = locale.value === 'pt' ? pt : enUS
      return messages.workWithUsPage.accountManager || {}
    })
    
    // Função para gerar rotas localizadas
    const getLocalizedRoute = (routeName) => {
      const currentLocale = locale.value === 'en-US' ? 'en' : 'pt'
      return routeName ? `/${currentLocale}/${routeName}` : `/${currentLocale}`
    }
    
    return {
      t,
      accountManager,
      getLocalizedRoute
    }
  }
}
</script>

<style scoped>
/* Estilos específicos da página AccountManager */
</style>
